var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreativeActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3337 16.0013C29.3337 8.6375 23.3641 2.66797 16.0003 2.66797C8.63653 2.66797 2.66699 8.6375 2.66699 16.0013C2.66699 23.365 8.63653 29.3346 16.0003 29.3346C17.1226 29.3346 18.667 29.4897 18.667 28.0013C18.667 27.1893 18.2446 26.5629 17.8251 25.9405C17.2113 25.03 16.6034 24.1284 17.3337 22.668C18.2226 20.8902 19.7041 20.8902 21.9757 20.8902C23.1115 20.8902 24.4449 20.8902 26.0003 20.668C28.8017 20.2678 29.3337 18.5458 29.3337 16.0013Z",
    stroke: "#243235",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 20.0032L9.34458 20",
    stroke: "#243235",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 13.332C13.7716 13.332 14.667 12.4366 14.667 11.332C14.667 10.2275 13.7716 9.33203 12.667 9.33203C11.5624 9.33203 10.667 10.2275 10.667 11.332C10.667 12.4366 11.5624 13.332 12.667 13.332Z",
    stroke: "#243235",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14.668C23.1046 14.668 24 13.7725 24 12.668C24 11.5634 23.1046 10.668 22 10.668C20.8954 10.668 20 11.5634 20 12.668C20 13.7725 20.8954 14.668 22 14.668Z",
    stroke: "#243235",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativeActive);
export default __webpack_public_path__ + "static/media/creative_active.eeb3c2b06c0de922505c2001234098ab.svg";
export { ForwardRef as ReactComponent };